;(function () {
  angular.module('contrast.date').constant('csDateRangePickerPrimaryStates', {
    SELECT: 'select',
    RANGE_PICKER: 'rangePicker'
  })
})()
